// Import enumerations.
import {
	EventType
} from '@app/enumerations';

export default class EventService {

	private static instance: EventService;

	private registeredEvents: { [eventType: string]: { [eventId: string]: (event: any) => void }}

	private constructor() {
		this.registeredEvents = {};
	}

	private intializeEvent(eventType: EventType): void {
		this.registeredEvents[eventType] = {}
		window.addEventListener(eventType, (event: any) => {
			Object.keys(this.registeredEvents[eventType]).forEach((eventId: string) => {
				if (this.registeredEvents[eventType][eventId] !== undefined) {
					this.registeredEvents[eventType][eventId](event)
				}
			});
		});
	}

    /**
     * Get a singleton instance of EventService.
     */
	public static getInstance(): EventService {
		if (!EventService.instance) {
			EventService.instance = new EventService();
		}
		return EventService.instance;
	}

	public registerEvent(eventId: string, eventType: EventType, event: (event: any) => void): void {
		// First try to initialize the event, if it hasn't already.
		if (this.registeredEvents[eventType] === undefined) {
			this.intializeEvent(eventType);
		}
		this.registeredEvents[eventType][eventId] = event;
	}
}
